export function preventOverscroll() {
  // Set document background color to prevent black areas
  document.documentElement.style.backgroundColor = '#f8f9fa';
  document.body.style.backgroundColor = '#f8f9fa';
  
  // Create a large background element to cover any exposed areas
  const bgDiv = document.createElement('div');
  bgDiv.style.cssText = `
    position: fixed;
    top: -200vh;
    left: -200vw;
    width: 400vw;
    height: 400vh;
    background-color: #f8f9fa;
    z-index: -999999;
    pointer-events: none;
  `;
  document.body.insertBefore(bgDiv, document.body.firstChild);
}